var _style, _path, _path2, _defs, _clipPath, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path5, _path6, _path7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: 0,
    y: 0,
    viewBox: "0 0 204 151",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#f5f4f3}.st3,.st4,.st9{fill:none;stroke-miterlimit:10}.st3{stroke-linecap:round;stroke-linejoin:round;stroke:#463527;stroke-width:2.5}.st4,.st9{stroke:#f95111;stroke-width:1.5}.st9{stroke:#ab947d;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.3 150.2c-31.9 0-71.8-26.7-65.7-48.1C28.7 80.8 62.9 83.4 44.2 56s9.2-45 72.1-38.4c62.9 6.6 100 47.4 82.8 72.7s-32.7 13-56.4 37.4c-23.7 24.4-22.4 22.5-54.4 22.5z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M126.5 76.4l4.5-4.5L115.1 56l-4.5 4.5 2.2 2.3-11.3 11.4h-9.1L89 77.6 109.4 98l3.4-3.4v-9.1l11.4-11.3z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M43 30h126v126H43z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_1_"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0af9f",
    fillRule: "evenodd",
    d: "M112 61.1l3.1-5.1L131 71.9l-5.7 3.4-5.5 3.3-11.1-11.1z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 76.4l4.5-4.5L115.1 56l-4.5 4.5 2.2 2.3-11.3 11.4h-9.1L89 77.6 109.4 98l3.4-3.4v-9.1l11.4-11.3zM99.1 87.9l-18 18",
    className: "st3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 125,
    r: 3,
    className: "st4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 128,
    r: 3,
    fill: "none",
    stroke: "#f95111",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    opacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 5.5,
    r: 4.5,
    fill: "none",
    stroke: "#8c7a67",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 72,
    r: 3,
    className: "st4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 136.5,
    r: 8.5,
    className: "st0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 11,
    r: 5,
    className: "st0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 58,
    r: 14,
    className: "st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ab947d",
    d: "M148.1 53l2.2-2.2c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.2 2.2-2.2-2.2c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1l2.2 2.2-2.2 2.2c-.3.3-.3.8 0 1.1.2.2.4.2.6.2s.4-.1.6-.2l2.2-2.2 2.2 2.2c.2.2.4.2.6.2s.4-.1.6-.2c.3-.3.3-.8 0-1.1l-2.4-2.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ab947d",
    d: "M59.3 34c-.2-.4-.7-.6-1.1-.4l-2.9 1.3L54 32c-.2-.4-.7-.6-1.1-.4-.4.2-.6.7-.4 1.1l1.3 2.9-2.9 1.3c-.4.2-.6.7-.4 1.1.1.3.4.5.7.5.1 0 .2 0 .3-.1l2.9-1.3 1.3 2.9c.1.3.4.5.7.5.1 0 .2 0 .3-.1.4-.2.6-.7.4-1.1l-1.3-2.9 2.9-1.3c.6-.2.8-.7.6-1.1z",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.2 133l7.6 2M153 130.2l-2 7.6",
    className: "st9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 96,
    r: 5,
    fill: "none",
    stroke: "#c0af9f",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPing);
export default __webpack_public_path__ + "static/media/ping.e2bfa1eb.svg";
export { ForwardRef as ReactComponent };